import httpClient from "./httpClient";

// Exam configuration (class × exam)
export function listExamConfigs(classId) {
  return httpClient.get("/exam-config", { params: { classId } }).then((res) => res.data.data);
}
export function saveExamConfig(payload) {
  return httpClient.post("/exam-config", payload).then((res) => res.data.data);
}
export function deleteExamConfig(id) {
  return httpClient.delete(`/exam-config/${id}`).then((res) => res.data);
}

// Short codes (mark components, per class)
export function listShortCodes(classId) {
  return httpClient.get("/exam-config/short-codes", { params: { classId } }).then((res) => res.data.data);
}
export function saveShortCode(payload) {
  return httpClient.post("/exam-config/short-codes", payload).then((res) => res.data.data);
}
export function deleteShortCode(id) {
  return httpClient.delete(`/exam-config/short-codes/${id}`).then((res) => res.data);
}

// Subject configuration (which subjects + short-code weights for an exam config)
export function listSubjectConfigs(examConfigId) {
  return httpClient.get("/exam-config/subject-configs", { params: { examConfigId } }).then((res) => res.data.data);
}
export function saveSubjectConfig(payload) {
  return httpClient.post("/exam-config/subject-configs", payload).then((res) => res.data.data);
}
export function deleteSubjectConfig(id) {
  return httpClient.delete(`/exam-config/subject-configs/${id}`).then((res) => res.data);
}

// Grade bands (per class)
export function listExamGrades(classId) {
  return httpClient.get("/exam-grades", { params: { classId } }).then((res) => res.data.data);
}
export function createExamGrade(payload) {
  return httpClient.post("/exam-grades", payload).then((res) => res.data.data);
}
export function deleteExamGrade(id) {
  return httpClient.delete(`/exam-grades/${id}`).then((res) => res.data);
}

// Mark entry
export function getExamMarkGrid(examConfigId, subjectId, classConfigurationId, groupId, academicYear) {
  return httpClient
    .get("/exam-marks", { params: { examConfigId, subjectId, classConfigurationId, groupId, academicYear } })
    .then((res) => res.data.data);
}
export function saveExamMarks(payload) {
  return httpClient.post("/exam-marks", payload).then((res) => res.data.data);
}
export function deleteExamMarks(markInputIds) {
  // Repeated-key query string, not axios's default markInputId[]=... bracket
  // form — see dashboardApi.js's getTotalStudent for why.
  const query = new URLSearchParams();
  markInputIds.forEach((id) => query.append("markInputId", id));
  return httpClient.delete(`/exam-marks?${query.toString()}`).then((res) => res.data);
}

// Result processing
export function processExamResults(payload) {
  return httpClient.post("/exam-results/process", payload).then((res) => res.data.data);
}
export function listExamResults(examConfigId) {
  return httpClient.get("/exam-results", { params: { examConfigId } }).then((res) => res.data.data);
}
export function getExamGradingPassFailSummary(examId, academicYear) {
  return httpClient
    .get("/exam-results/grading-pass-fail-summary", { params: { examId, academicYear } })
    .then((res) => res.data.data);
}
export function listExamMarksForClass(examConfigId, classConfigId, academicYear) {
  return httpClient
    .get("/exam-marks/for-class", { params: { examConfigId, classConfigId, academicYear } })
    .then((res) => res.data.data);
}
export function processExamMarks(examConfigId, classConfigurationId, academicYear) {
  return httpClient
    .post("/exam-marks/process", null, { params: { examConfigId, classConfigurationId, academicYear } })
    .then((res) => res.data);
}

export function processGrandFinalResult(examConfigId, academicYear) {
  return httpClient
    .post("/exam-results/grand-final/process", null, { params: { examConfigId, academicYear } })
    .then((res) => res.data);
}

/** "Merit Generate" (`exam-merit-position-generate`) — see ExamResultService#generateMeritPosition's javadoc. */
export function generateMeritPosition(examConfigId, academicYear) {
  return httpClient
    .post("/exam-results/merit-position/generate", null, { params: { examConfigId, academicYear } })
    .then((res) => res.data);
}

/** "Subject Wise Grade" (`exam-report-subject-wise-grading-summary`) — see ExamResultService#classWiseSubjectGradingSummary's javadoc. */
export function getSubjectWiseGradingSummary(examConfigId, academicYear, classConfigId, groupId) {
  return httpClient
    .get("/exam-results/subject-wise-grading-summary", { params: { examConfigId, academicYear, classConfigId, groupId } })
    .then((res) => res.data.data);
}
